import type {FC} from 'react'
import {useEffect, useState} from 'react'
import {useQuery} from 'react-query'
import {PageTitle} from '../../../_metronic/layout/core'
import {DropdownDefault, InputDefault, TabsDefault} from '../../components/ui'
import ModalImport from '../../components/sections/ModalImport'
import TableTransaction from '../../components/sections/TableTransaction'
import {
  getListTransactionRecords,
  importReceiptTransactions,
} from '../../modules/services/transactions.service'
import {getBreadCrumbs} from './breadcrumbs'
import {members} from '../../mocks/'

interface TableWrapperProps {
  type: string
  search: string
}

const EnablerPage: FC = () => {
  const [filter, setFilter] = useState('')
  const [search, setSearch] = useState('')

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Shopee Transaction</p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#import-modal'
              >
                Import
              </button>
            </div>
            <div className='d-flex flex-row gap-4'>
              <InputDefault
                placeholder='Search'
                left={<i className='bi bi-search' />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <DropdownDefault
                type='Filter'
                list={members.filters}
                dataState={[filter, setFilter]}
              />
            </div>
          </div>
        </div>
        <TabsDefault
          tabs={['Ongoing', 'Valid', 'Invalid']}
          contents={[
            <TableWrapper type='waiting' search={search} />,
            <TableWrapper type='valid' search={search} />,
            <TableWrapper type='invalid' search={search} />,
          ]}
        />
        <ModalImport service={importReceiptTransactions} isXLSX />
      </div>
    </>
  )
}

const TableWrapper: FC<TableWrapperProps> = ({type, search}) => {
  const headFields = ['Date', 'Username', 'Transaction ID', 'Product']
  const bodyFields = [
    'attributes.finishedDate',
    'attributes.username',
    'attributes.orderNumber',
    'attributes.productName',
  ]
  const [page, setPage] = useState(1)

  const {data} = useQuery(['getListTransactionRecords', search, page, type], async () =>
    getListTransactionRecords(search, page, type)
  )
  const datas = data?.data
  const pageCount = data?.meta?.pagination.pageCount

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }
  return (
    <TableTransaction
      head={headFields}
      body={bodyFields}
      data={datas}
      href='enabler'
      allPaginate={pageCount}
      page={page}
      setsPage={setPage}
      nextPage={nextPage}
      prevPage={prevPage}
      isReverse={type !== 'waiting'}
    />
  )
}

const EnablerWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/enabler')}>Enabler</PageTitle>
      <EnablerPage />
    </>
  )
}

export default EnablerWrapper
